import * as PropTypes from "prop-types"
import React from "react"
import { Link, PageRenderer } from "gatsby"

import { rhythm, scale } from "../utils/typography"
import presets from "../utils/presets"

let Modal
import(`../components/modal`).then(modal => {
  Modal = modal.default
})

let windowWidth

class Layout extends React.Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
    isModal: PropTypes.bool,
  }

  render() {
    const { location } = this.props
    let isModal = false
    if (!windowWidth && typeof window !== `undefined`) {
      windowWidth = window.innerWidth
    }
    if (this.props.isModal && windowWidth > 750) {
      isModal = true
    }

    if (isModal && Modal) {
      return (
        <React.Fragment>
          <PageRenderer location={{ pathname: `/` }} />
          <Modal isOpen={true} location={location}>
            {this.props.children}
          </Modal>
        </React.Fragment>
      )
    }

    return (
      <div
        css={{
          background: `rgba(0,0,0,0.03)`,
          background: `#f6f2e9`,
          minHeight: `100vh`,
        }}
      >
        <div
          css={{
            background: `#98cfbf`,
            color: `white`,
            borderBottom: `1px solid rgba(0,0,0,0.08)`,
          }}
        >
          <div
            css={{
              padding: rhythm(3 / 4),
              paddingBottom: `calc(${rhythm(3 / 4)} - 1px)`,
              maxWidth: 960,
              margin: `0 auto`,
              overflow: `hidden`,
            }}
          >
            <Link
              to="/"
              css={{
                display: `inline-block`,
                float: `left`,
                textDecoration: `none`,
              }}
            >
              <h1
                data-testid="site-title"
                css={{
                  ...scale(4 / 5),
                  lineHeight: 1,
                  margin: 0,
                  overflow: `hidden`,
                }}
              >
                <img css={{
                    height: '30px',
                    marginBottom: '0'
                }} src={`data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0D%0A%3C%21--%20Generator%3A%20Adobe%20Illustrator%2017.0.0%2C%20SVG%20Export%20Plug-In%20.%20SVG%20Version%3A%206.00%20Build%200%29%20%20--%3E%0D%0A%3C%21DOCTYPE%20svg%20PUBLIC%20%22-%2F%2FW3C%2F%2FDTD%20SVG%201.1%2F%2FEN%22%20%22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%0D%0A%3Csvg%20version%3D%221.1%22%20id%3D%22logo__x2B__blinks%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%0D%0A%09%20y%3D%220px%22%20width%3D%22284.99px%22%20height%3D%22169.154px%22%20viewBox%3D%220%200%20284.99%20169.154%22%20enable-background%3D%22new%200%200%20284.99%20169.154%22%0D%0A%09%20xml%3Aspace%3D%22preserve%22%3E%0D%0A%3Cg%20id%3D%22dubble_logo%22%3E%0D%0A%09%3Cpath%20fill%3D%22%23FFFFFA%22%20d%3D%22M284.99%2C84.577c0%2C0-41.425%2C84.577-142.495%2C84.577l0%2C0C41.425%2C169.154%2C0%2C84.577%2C0%2C84.577S41.425%2C0%2C142.495%2C0%0D%0A%09%09l0%2C0C243.564%2C0%2C284.99%2C84.577%2C284.99%2C84.577z%22%2F%3E%0D%0A%09%3Ccircle%20fill%3D%22%23A3CCBF%22%20cx%3D%22142.495%22%20cy%3D%22111.81%22%20r%3D%2227.233%22%2F%3E%0D%0A%09%3Ccircle%20fill%3D%22%235E594A%22%20cx%3D%22142.495%22%20cy%3D%2264.44%22%20r%3D%2227.233%22%2F%3E%0D%0A%3C%2Fg%3E%0D%0A%3C%2Fsvg%3E%0D%0A`}/>
                <span
                  css={{
                    paddingLeft: `calc(${rhythm(1)} - 1px)`,
                    borderLeft: `1px solid white`,
                    lineHeight: 1,
                    color: 'white',
                    marginLeft: rhythm(1),
                  }}
                >
                  Dubble
                </span>
              </h1>
            </Link>
            <Link
              data-testid="about-link"
              to="/about/"
              css={{
                color: `inherit`,
                display: `inline-block`,
                float: `right`,
                lineHeight: `35px`,
                textDecoration: `none`,
              }}
            >
              About
            </Link>
          </div>
        </div>
        <div
          css={{
            maxWidth: 960,
            margin: `0 auto`,
            [presets.Tablet]: {
              padding: rhythm(3 / 4),
            },
          }}
        >
          {this.props.children}
        </div>
      </div>
    )
  }
}

export default Layout
